import SeamApi from '../lib/seam-api';

const teamIds = {
    'start': 2,
    'invest': 3,
    'grow': 4,
    'innovate': 7,
}

document.addEventListener('DOMContentLoaded', () => {
    const firstName = document.getElementById('first-name');
    const lastName = document.getElementById('last-name');

    const message = document.getElementById('message');
    const email = document.getElementById('email');

    const phoneNumber = document.getElementById('phone-number');

    const form = document.getElementById('contact-us-form');
    const error = document.getElementById('contact-us-error');

    const type = form.getAttribute('data-type');

    const mailingList = document.getElementById('mailing-list-accept');

    const disableForm = () => {
        form.classList.add('form--completed')

        Array.from(form.elements).forEach(formElement => formElement.disabled = true);
    }

    if (form) {
        form.addEventListener('submit', (event) => {
            let params = {
                source_distribution_id : 1,
                subject: 'Contact Us',
                contact_permissions : [],
                email: email?.value,
                first_name: firstName?.value,
                last_name: lastName?.value,
                phone_number: phoneNumber?.value,
                message: message?.value,
            };

            if (teamIds?.[type] !== undefined) {
                params.admin_team_id = teamIds[type];
            } else {
                params.admin_team_id = 6;
            }

            if (mailingList.checked) params.contact_permissions.push(1);

            SeamApi.contacts().message(params, (err) => {
                if (err.hasOwnProperty('email')) {
                    email.classList.toggle('border-gray-300');
                    email.classList.add('border-red-400');
                }

                error.innerText = 'There seems to have been an error';
                error.className = 'text-sm font-medium text-red-500';
             }).then(() => {
                error.innerText = 'Successfully enquired! You will hear back shortly';
                error.className = 'text-sm font-medium text-green-500';

                disableForm();
             });

            event.preventDefault();
        });
    }
});
